import { useContext, useReducer } from "react";
import { ICreateBeneficiaryGroup, IUpdateBeneficiaryGroup } from "../../models/beneficiary-groups/request";
import EndPoints from "../../services/end-points";
import { execute } from "../../utils/helpers/execute";
import AppContext from "../app/context";
import BeneficiaryGroupContext, { internalState } from "./context";
import reducer from "./reducer";

export interface IProps {
  children: React.ReactNode;
}

const BeneficiaryGroupProvider: React.FC<IProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const { direction } = useContext(AppContext);

  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
        const { data } = await EndPoints.beneficiaryGroup.getAllBeneficiaryGroups({ ...state.query });
        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
        const { data } = await EndPoints.beneficiaryGroup.getBeneficiaryGroup(id);
        dispatch({ type: "SET_DETAILSS", payload: { details: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = (data?: any) => {
    dispatch({ type: "SET_DETAILSS", payload: { details: data } });
  };

  const createBeneficiaryGroup = async (request: ICreateBeneficiaryGroup) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "create" } });
        await EndPoints.beneficiaryGroup.createBeneficiaryGroup(request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "create" } });
      },
      throwException: true,
    });
  };

  const updateBeneficiaryGroup = async (id: number, request: IUpdateBeneficiaryGroup) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "update" } });
        await EndPoints.beneficiaryGroup.updateBeneficiaryGroup(id, request);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "update" } });
      },
      throwException: true,
    });
  };

  const deleteBeneficiaryGroup = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "delete" } });
        await EndPoints.beneficiaryGroup.deleteBeneficiaryGroup(id);
        getData();
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "delete" } });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: any) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };

  return (
    <BeneficiaryGroupContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getDetails,
          setDetails,
          createBeneficiaryGroup,
          updateBeneficiaryGroup,
          deleteBeneficiaryGroup,
          setSearch,
          setQuery,
        },
      }}
    >
      {children}
    </BeneficiaryGroupContext.Provider>
  );
};

export default BeneficiaryGroupProvider;
